import dayjs from 'dayjs';
import { Navigate, View, Views } from 'react-big-calendar';

export const getAdditionalRanges = (
  currentView: View,
  currentAction: any,
  start: Date,
  end: Date
): Array<{ start: Date; end: Date }> => {
  let ranges: Array<{ start: Date; end: Date }> = [];

  if (currentView === Views.DAY) {
    if (currentAction !== Navigate.PREVIOUS) {
      const nextStart = new Date(end.getTime() + 1);
      const nextEnd = dayjs(nextStart).endOf('day').toDate();
      const next2Start = new Date(nextEnd.getTime() + 1);
      const next2End = dayjs(next2Start).endOf('day').toDate();

      ranges = [
        { start: nextStart, end: nextEnd },
        { start: next2Start, end: next2End },
      ];
    } else {
      const nextEnd = new Date(start.getTime() - 1);
      const nextStart = dayjs(nextEnd).startOf('day').toDate();
      const next2End = new Date(nextStart.getTime() - 1);
      const next2Start = dayjs(next2End).startOf('day').toDate();

      ranges = [
        { start: nextStart, end: nextEnd },
        { start: next2Start, end: next2End },
      ];
    }
  }

  if (currentView === Views.WEEK) {
    if (currentAction !== Navigate.PREVIOUS) {
      const nextStart = new Date(end.getTime() + 1);
      const nextEnd = dayjs(nextStart).endOf('week').endOf('day').toDate();
      const next2Start = new Date(nextEnd.getTime() + 1);
      const next2End = dayjs(next2Start).endOf('week').endOf('day').toDate();

      ranges = [
        { start: nextStart, end: nextEnd },
        { start: next2Start, end: next2End },
      ];
    } else {
      const nextEnd = new Date(start.getTime() - 1);
      const nextStart = dayjs(nextEnd).startOf('week').startOf('day').toDate();
      const next2End = new Date(nextStart.getTime() - 1);
      const next2Start = dayjs(next2End).startOf('week').startOf('day').toDate();

      ranges = [
        { start: nextStart, end: nextEnd },
        { start: next2Start, end: next2End },
      ];
    }
  }

  if (currentView === Views.MONTH) {
    if (currentAction !== Navigate.PREVIOUS) {
      const nextStart = new Date(end.getTime() + 1);
      const nextEnd = dayjs(nextStart).endOf('month').endOf('week').endOf('day').toDate();
      const next2Start = new Date(nextEnd.getTime() + 1);
      const next2End = dayjs(next2Start).endOf('month').endOf('week').endOf('day').toDate();

      ranges = [
        ...ranges,
        { start: nextStart, end: nextEnd },
        { start: next2Start, end: next2End },
      ];
    } else {
      const nextEnd = new Date(start.getTime() - 1);
      const nextStart = dayjs(nextEnd).startOf('month').startOf('week').startOf('day').toDate();
      const next2End = new Date(nextStart.getTime() - 1);
      const next2Start = dayjs(next2End).startOf('month').startOf('week').startOf('day').toDate();

      ranges = [
        ...ranges,
        { start: nextStart, end: nextEnd },
        { start: next2Start, end: next2End },
      ];
    }
  }

  return ranges;
};
